const DATA_LOADING_STATE = {
    INIT:0,
    CREATING:1,
    CREATED: 2,
    ERROR: 3
}

export default DATA_LOADING_STATE;